import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { modalClassnames } from '../Modal';

export const PopoverModal = ({ popover }: { popover: ReactNode }) => {
  return (
    <>
      {createPortal(
        <div className={modalClassnames}>{popover}</div>,
        document.body,
      )}
    </>
  );
};
